import type { IValidatedResponse } from '../../../httpClient';
import { getRequest } from '../../../httpClient';
import type { IListWebhookEventsResponse } from '../listWebhookEvents/list-webhook-events-response';
import { listWebhookEventsResponseSchema } from '../listWebhookEvents/list-webhook-events-response';

export async function listUserWebhookEventsApi(
  userId: string,
): Promise<IValidatedResponse<IListWebhookEventsResponse>> {
  return getRequest<IListWebhookEventsResponse>({
    path: `/sys/billing/users/${userId}/webhook-events`,
    schema: listWebhookEventsResponseSchema,
  });
}
